export class EnvService {
  static get(key) {
    const request = new XMLHttpRequest();
    request.open('GET', './config.json', false);
    request.send(null);

    if (request.status === 200) {
      const data = JSON.parse(request.responseText);
      const prefix = 'REACT_APP_' + key;
      return data[prefix];
    }
  }
}

// Configuração usada para rodar aplicação localhost. Não retirar código comentado!
/*
export class EnvService {
  static get(key) {
    const prefix = 'REACT_APP_' + key;
    return process.env[prefix];
  }
}
*/
